import { request } from 'utils/request';
import { header } from 'utils/auth';

const fetchMyautoiqNurturingJourneySettingsFromAPI = async ({
  manufacturerId,
}: {
  manufacturerId: string;
}): Promise<any> => {
  try {
    const requestURL = `/api/v2/myautoiq-settings?manufacturer_id=${manufacturerId}&type=NURTURING_JOURNEY_CONFIG`;
    const response: any = await request(requestURL, {
      method: 'GET',
      headers: new Headers({
        'Content-Type': 'application/json',
        Authorization: header(),
      }),
    });

    if (!response) {
      throw new Error('Failed to fetch myautoiq nurturing journey settings from API');
    }
    return await response;
  } catch (error) {
    console.error('Error fetching myautoiq nurturing journey settings:', error);
    throw error;
  }
};

export const fetchMyautoiqNurturingJourneySettings = async ({
  manufacturerId,
}: {
  manufacturerId: string;
}): Promise<any> => {
  return fetchMyautoiqNurturingJourneySettingsFromAPI({ manufacturerId });
};

export const saveMyautoiqNurturingJourneySettings = async ({
  manufacturerId,
  payload,
}: {
  manufacturerId: string;
  payload: { manufacturer_id: string; segments: any[] };
}): Promise<any> => {
  try {
    const requestURL = `/api/v2/myautoiq-settings?manufacturer_id=${manufacturerId}&type=NURTURING_JOURNEY_CONFIG`;
    const response: any = await request(requestURL, {
      method: 'PUT',
      headers: new Headers({
        'Content-Type': 'application/json',
        Authorization: header(),
      }),
      body: JSON.stringify(payload),
    });

    if (!response) {
      throw new Error('Failed to save myautoiq nurturing journey settings');
    }
    const res = await response;
    const status = res?.statusCode ?? res?.myAutoIQ_status_code ?? res?.errorCode;
    const msg = res?.message ?? res?.myAutoIQ_error_message;
    if (typeof status === 'number' && status >= 400) {
      throw new Error(msg || 'Failed to save myautoiq nurturing journey settings');
    }
    return res;
  } catch (error) {
    console.error('Error saving myautoiq nurturing journey settings:', error);
    throw error;
  }
};

const initializeMyautoiqNurturingJourneySettingsFromAPI = async ({
  manufacturerId,
}: {
  manufacturerId: string;
}): Promise<any> => {
  try {
    const requestURL = `/api/v2/myautoiq-settings/initialize?manufacturer_id=${manufacturerId}&type=NURTURING_JOURNEY_CONFIG`;
    const response: any = await request(requestURL, {
      method: 'POST',
      headers: new Headers({
        'Content-Type': 'application/json',
        Authorization: header(),
      }),
    });

    if (!response) {
      throw new Error('Failed to initialize myautoiq nurturing journey settings from API');
    }
    const res = await response;
    const status = res?.statusCode ?? res?.myAutoIQ_status_code ?? res?.errorCode;
    const msg = res?.message ?? res?.myAutoIQ_error_message;
    if (typeof status === 'number' && status >= 400) {
      throw new Error(msg || 'Failed to initialize myautoiq nurturing journey settings');
    }
    return res;
  } catch (error) {
    console.error('Error initializing myautoiq nurturing journey settings:', error);
    throw error;
  }
};

export const initializeMyautoiqNurturingJourneySettings = async ({
  manufacturerId,
}: {
  manufacturerId: string;
}): Promise<any> => {
  return initializeMyautoiqNurturingJourneySettingsFromAPI({ manufacturerId });
};
